import { RATE_CATEGORY } from "@/constants/project-constant";
import { ProjectContext } from "@/context/project.context";
import { voteCategoryColor } from "@/utils";
import { Progress } from "antd";
import { useContext, useMemo } from "react";

const Evaluation = () => {
  const { project } = useContext(ProjectContext);

  const isShowVoteScore = useMemo(() => {
    const isHasScore = project?.votes?.find((vote) => vote.score > 0);
    if (isHasScore) {
      return true;
    }
    return false;
  }, [project?.votes]);
  return isShowVoteScore ? (
    <>
      <div className="bg-white p-3 m-4 h-full">
        <div className="flex flex-col gap-3">
          {project?.votes && project?.votes?.length
            ? project?.votes.map((vote: any) => {
                const label = RATE_CATEGORY.find(
                  (rate) => rate.key == vote.voteCategory
                )?.title;

                return (
                  <div
                    className="flex items-center gap-3 justify-between"
                    key={vote.voteCategory}>
                    <span className="text-grey-700 font-medium text-fs-14 w-[80px] shrink-0">
                      {label}
                    </span>
                    <Progress
                      percent={vote?.score * 2 * 10}
                      showInfo={false}
                      strokeColor={{
                        "0%": voteCategoryColor(vote?.score),
                        "100%": voteCategoryColor(vote?.score),
                      }}
                      className="mb-0 mr-0"
                    />
                    <span className="text-grey-700 text-fs-14 font-medium whitespace-nowrap">
                      {Number.isInteger(vote?.score)
                        ? vote?.score
                        : vote?.score?.toFixed(1)}
                      /5
                    </span>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default Evaluation;
